export function hexToRGB(hexColor, opacity) {
    var r = 0;
    var g = 0;
    var b = 0;
    // 3 digits
    if (hexColor.length === 4) {
        r = "0x".concat(hexColor[1]).concat(hexColor[1]);
        g = "0x".concat(hexColor[2]).concat(hexColor[2]);
        b = "0x".concat(hexColor[3]).concat(hexColor[3]);
        // 6 digits
    }
    else if (hexColor.length === 7) {
        r = "0x".concat(hexColor[1]).concat(hexColor[2]);
        g = "0x".concat(hexColor[3]).concat(hexColor[4]);
        b = "0x".concat(hexColor[5]).concat(hexColor[6]);
    }
    return opacity ? "rgba(".concat(+r, ",").concat(+g, ",").concat(+b, ",").concat(opacity, ")") : "rgb(".concat(+r, ",").concat(+g, ",").concat(+b, ")");
}
